/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MoveSlackNotificationSettingForCardRequest
 */
export interface MoveSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'transactionTypes': Array<MoveSlackNotificationSettingForCardRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'groupIds': Array<string>;
}

export const MoveSlackNotificationSettingForCardRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type MoveSlackNotificationSettingForCardRequestTransactionTypesEnum = typeof MoveSlackNotificationSettingForCardRequestTransactionTypesEnum[keyof typeof MoveSlackNotificationSettingForCardRequestTransactionTypesEnum];


